import { details } from "../utils/static";
import { useContext } from "react";
import { AppContext } from "../context/context";

function Details() {
  const { setState } = useContext(AppContext);

  return (
    <div
      id="details"
      className="w-full h-fit py-16 md:py-32 px-8 smd:px-12 md:px-16 flex flex-col items-center gap-16 md:gap-32 lg:gap-48"
    >
      {details.map((detail, index) => (
        <div
          key={index}
          className={`w-full max-w-[1340px] h-fit flex ${
            (index + 1) % 2 === 0 ? "lg:flex-row-reverse" : "lg:flex-row"
          } flex-col lg:flex-row items-center gap-8 lg:gap-12`}
        >
          <div className="max-w-[600px] lg:w-1/2 h-fit flex flex-col">
            <h6 className="text-[22px] text-center md:text-left smd:text-[32px] md:text-[38px] xxl:text-[48px] font-bold leading-tight mb-1">
              {detail.name}
            </h6>
            <p className="text-sm text-center md:text-left xxl:text-base text-gray-500 mt-2">
              {detail.description}
            </p>

            <div className="w-full flex flex-col md:flex-row gap-8 mt-4 md:mt-8">
              <div className="w-full h-fit flex flex-col items-center md:items-start">
                <div
                  className={`w-14 h-14 flex items-center justify-center ${
                    (index + 1) % 2 === 0 ? "bg-teal" : "bg-purp"
                  } rounded-md text-white`}
                >
                  <span className="w-8">{detail.leftIcon}</span>
                </div>

                <h1 className="text-md text-center md:text-left md:text-xl font-bold mt-2 md:mt-8">
                  {detail.leftName}
                </h1>

                <p className="text-sm text-center md:text-left mt-1 md:mt-2">
                  {detail.leftDescription}
                </p>
              </div>

              <div className="w-full h-fit flex flex-col items-center md:items-start">
                <div
                  className={`w-14 h-14 flex items-center justify-center ${
                    (index + 1) % 2 === 0 ? "bg-teal" : "bg-purp"
                  } rounded-md text-white`}
                >
                  <span className="w-8">{detail.rightIcon}</span>
                </div>

                <h1 className="text-md text-center md:text-left md:text-xl font-bold mt-2 md:mt-8">
                  {detail.rightName}
                </h1>

                <p className="text-sm text-center md:text-left mt-1 md:mt-2">
                  {detail.rightDescription}
                </p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 h-fit">
            <img
              src={detail.image}
              alt="one"
              className="w-full"
              onLoad={() => {
                setState((p) => ({ ...p, loadedImages: p.loadedImages + 1 }));
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default Details;
